import BackgroundImg from '../../assets/imgs/backgroundImg.webp';

import { Achievements } from './Achievements';

export const Opening = () => {
	return (
		<div className='hidden md:block'>
			<div className='relative flex h-[calc(100vh_-_64px)] w-screen'>
				<div className='relative h-[calc(100vh_-_64px)] w-[50vw] rounded-bl-lg rounded-br-lg'>
					<div className='flex h-full w-full flex-col justify-evenly rounded-bl-lg rounded-br-lg'>
						<div className='container flex items-center justify-center'>
							<div className='rounded-md p-0 font-bold text-white'>
								<img
									alt='Sawaed logo'
									src='/logo-white.webp'
									fetchPriority='high'
									width={440}
									height={283}
									className='mb-12 h-auto w-[22vw] translate-y-0'
								/>
								<h2 className='mb-2 flex -translate-x-2 items-center justify-center gap-2 font-poppins text-2xl font-normal leading-none tracking-tighter'>
									<span> Build the </span>
									<div className='typewriter inline-flex items-end'>
										<span className='m-0 inline-block h-full border-l-[3px] border-solid border-primary-700 pb-1 pl-3 pr-4 pt-2 font-Sarah text-2xl font-semibold leading-none tracking-wide text-primary-800 [background:linear-gradient(_90deg,#fff_-5%,rgba(255,255,255,0)_100%_)]'>
											FUTURE
										</span>
									</div>
								</h2>
								<h2 className='flex translate-x-12 items-center justify-center gap-2 font-poppins text-2xl font-normal leading-none tracking-tighter'>
									Build with{' '}
									<div className='typewriter inline-flex items-end'>
										<span className='inline-block border-l-[3px] border-solid border-primary-700 pb-1 pl-3 pr-4 pt-2 font-Sarah text-2xl font-semibold leading-none tracking-wide text-primary-800 [background:linear-gradient(_90deg,#fff_-5%,rgba(255,255,255,0)_100%_)]'>
											TRUST
										</span>
									</div>
								</h2>
							</div>
						</div>

						<Achievements />
					</div>
				</div>
				<div className='relative h-[calc(100vh_-_64px)] w-[50vw] rounded-bl-lg rounded-br-lg border-[4px] border-[#1c295a]'>
					<div className='relative h-full w-full overflow-hidden rounded-bl-lg rounded-br-lg'>
						{/* Background image */}
						<img
							className='h-full w-full object-cover'
							src={BackgroundImg}
							alt=''
							width={1230}
							height={994}
						/>
						{/* Gradient overlay */}
						<div className='absolute inset-0 bg-gradient-to-l from-transparent to-[#1c295a]'></div>
					</div>
				</div>
			</div>
			<div
				id='more-sections'
				className='absolute bottom-0 left-0 right-0 z-0'
			/>
		</div>
	);
};
